<template>
  <div class="koc-block koc-purchase-disclaimer-single-block">
    <p class="koc-disclaimer">
      <template v-if="preview.next">
        By clicking "Confirm Payment", you agree to the purchase of
        {{ formatProduct(preview.next.product.handle) }}. Your payment method
        provided will be charged for the amount of
        {{ formatPrice(preview.next.payment.total) }}
        plus applicable taxes.
      </template>
    </p>
  </div>
</template>

<script src="./single.js"></script>
<style lang="scss" scoped src="./single.scss"></style>